import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router';
// import { Loader } from '~/shared/components';
// import { useNavAndFilters } from '~/shared/services/charts';
// import GridPage from './ChartsPage/GridPage';
// import HeatmapPage from './ChartsPage/HeatmapPage';
// import HorizontalBarChartPage from './ChartsPage/HorizontalBarChartPage';
// import IframePage from './ChartsPage/IframePage';
// import TableChartPage from './ChartsPage/TableChartPage';
// import StackedBarChartPage from './ChartsPage/StackedBarChartPage';
// import ScatterChartPage from './ChartsPage/ScatterChartPage';
// import VideoPlayerPage from './ChartsPage/VideoPlayerPage';

// const AlignedLoader = styled(Loader)`
//   left: calc(50% - 25px);
//   top: calc(50% - 25px);
// `;

const PageWrapper = styled.div`
  padding-top: 0;
`;

export default function ChartsPage() {
  const location = useLocation();

  const category = location.pathname.split('/')[2];

  const id = location.search.split('=')[1];

  return (
    <PageWrapper>
      hi from {category} - {id}
    </PageWrapper>
  );
}
